import React from "react";
import { t } from "i18next";
import Dropdown from "@/components/ui/dropdown";
import styles from "./index.module.scss";

export interface PollSelectOption {
  label: string;
  value: string;
}

export interface PollSelectProps {
  /** Options for the dropdown */
  options: PollSelectOption[];
  /** Current selected value */
  value: string | null;
  /** Called when selection changes */
  onChange: (value: string) => void;
  /** Placeholder when nothing selected (default: "Seçiniz") */
  placeholder?: string;
  /** Disable the select */
  disabled?: boolean;
  /** Optional className for the root container */
  className?: string;
}

export const PollSelect: React.FC<PollSelectProps> = ({
  options,
  value,
  onChange,
  placeholder = t("select"),
  disabled = false,
  className,
}) => {
  const selectedLabel = value
    ? options.find((o) => o.value === value)?.label ?? undefined
    : undefined;

  return (
    <div className={`${styles.root} ${className ?? ""}`}>
      <Dropdown
        options={options}
        value={value}
        onSelect={(v) => onChange(typeof v === "string" ? v : "")}
        selectedLabel={selectedLabel}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default PollSelect;
